import { connect } from "react-redux";
import Close from "../../../../assets/icon/svg/close";
import Modal from "../../../shared/components/modal";
import { fetchPostReels, fetchPosts } from "../../../../store/action/postAction";
import { addPostCampaign, fetchListPostCampaign } from "../../../../store/action/campaignsAction";
import { useEffect, useState } from "react";
import { formatTimeTxt } from "../../../../services/helpers/Helper";
import { useParams } from "react-router-dom";
const _ = require('lodash');
const TABS = {
   POSTS: 'POSTS',
   REELS: 'REELS'
}
const Posts = (props) => {
   const { onClose, page, posts, fetchPosts, addPostCampaign, listIdSelected, fetchPostReels } = props;
   const params = useParams();
   const { id } = params;
   const [listPostSelected, setListPostSelected] = useState([]);
   const [tab, setTab] = useState(TABS.POSTS);

   useEffect(() => {
      switch (tab) {
         case TABS.POSTS:
            fetchPosts();
            break;
         case TABS.REELS:
            fetchPostReels();
            break;
         default:
            fetchPosts();
            break;
      }

   }, [page, tab]);

   const handleAddPostCampaign = () => {
      const data = posts.filter((f) => {
         return _.includes(listPostSelected, f.id)
      }).map((m) => {
         return {
            campaigns_manage_id: id,
            post_id: getPostId(m),
            post_name: m.message,
            post_description: m.message,
            post_picture: m.full_picture,
            post_created: new Date(m.created_time),
            is_active: 1,
            fb_page_id: page.social_id
         }
      });
      addPostCampaign(data);
      onClose()
   }

   const handleSelected = (e, post_id) => {
      if (_.includes(listIdSelected, post_id)) {
         return;
      }
      setListPostSelected(oldArray => {
         if (e.target.checked) {
            return [...oldArray, post_id];
         } else {
            return oldArray.filter((f) => f !== post_id);
         }
      });
   }

   const renderDesc = (item) => {
      if (_.includes(listIdSelected, item.id)) {
         return (
            <div className="display-flex">
               <div><span className="auto-comment-post-item__dot"></span></div>
               <div className="auto-comment-post-item__label text-font-weight-500 auto-comment-post-item__label--green">
                  <div><a target="_blank"><span>Đã được chọn</span></a></div>
               </div>
            </div>
         );
      }
      if (item.is_used_another_campaign) {
         return (
            <div className="display-flex pointer">
               <div><span className="auto-comment-post-item__dot"></span></div>
               <div className="auto-comment-post-item__label text-font-weight-500 auto-comment-post-item__label--yellow">
                  <div>
                     <span>Không khả dụng</span>
                     <span className="ml5">
                        <div className="svg-next-icon ic_link">
                        </div>
                     </span>
                  </div>
               </div>
            </div>
         )
      }
   }

   const getPostId = (item) => {
      switch (tab) {
         case TABS.POSTS:
            return item.id
         case TABS.REELS:
            return item.post_id
         default:
            return item.id
      }
   }

   const getPicture = (item) => {
      switch (tab) {
         case TABS.POSTS:
            return item.full_picture
         case TABS.REELS:
            return item.picture
         default:
            return item.full_picture
      }
   }

   return (
      <Modal>
         <div className="modal-dialog app-modal auto-comment-modal-select line-height-20 modal-lg" role="document">
            <div className="modal-content">
               <div className="app-modal-header">
                  <h4 className="app-modal-title">Bài viết bán hàng tự động</h4>
                  <span className="app-close" onClick={onClose}>
                     <Close />
                  </span>
               </div>
               <div className="app-modal-body">
                  <div className="dynamic-tabs-container auto-comment-modal-select__dynamic-tab">
                     <div className="tabs-header-container">
                        <div className="wrap-item">
                           <div className={`tabs-header-item ${tab === TABS.POSTS && "active"}`} onClick={() => setTab(TABS.POSTS)}>
                              <div className="tab-item-title"><span>Chọn bài viết đã đăng</span></div>
                           </div>
                           <div className={`tabs-header-item ${tab === TABS.REELS && "active"}`} onClick={() => setTab(TABS.REELS)}>
                              <div className="tab-item-title"><span>Chọn bài Reels</span></div>
                           </div>
                           {/* <div className="tabs-header-item">
                              <div className="tab-item-title"><span>Chọn bài viết quảng cáo ẩn</span></div>
                           </div>
                           <div className="tabs-header-item">
                              <div className="tab-item-title"><span>Nhập đường dẫn (bài viết, quảng cáo)</span></div>
                           </div> */}
                        </div>
                     </div>
                     <div>
                        <div className="auto-cmt-alert">
                           <div className="svg-next-icon icon-info ic-warning-circle">
                           </div>
                           <span className="ml6">
                              <b>Lưu ý:</b> Trường hợp bài viết <b>không khả dụng</b> do đang được
                              sử dụng ở công cụ khác, bạn cần bỏ chọn bài viết ở công cụ cũ trước khi áp dụng ở công cụ
                              mới này.
                           </span>
                        </div>
                        <div className="auto-comment-modal-select__mask-container">
                           <div className="auto-comment-modal-select__post-container">
                              {posts.map((item, index) => {
                                 return (
                                    <div className={`auto-comment-post-item display-flex align-items-center justify-content-space-between line-height-20 ps-relative auto-comment-modal-select__post-item ${item.is_used_another_campaign && "auto-comment-post-item--disabled"}`} key={index}>
                                       <div className="display-flex align-items-center">
                                          <div className="pd-all-20">
                                             <div className={`app-next-input-checkbox ${_.includes(listIdSelected, item.id) && "app-input-disabled"}`}>
                                                <label className="app-next-label--switch app-next-label--empty" for="app-checkbox-108"></label>
                                                <input id="app-checkbox-108" type="checkbox" className="app-next-checkbox" checked={_.includes([...listIdSelected, ...listPostSelected], item.id)} onChange={(e) => handleSelected(e, item.id)} disabled={item.is_used_another_campaign} />
                                                <span className="app-next-checkbox--styled">
                                                   <span className="app-svg-next-icon app-checkmark app-checkmark-v2">
                                                      <svg className="app-svg-inline-block" width="10px" height="10px" viewBox="0 0 26 26">
                                                         <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z">
                                                         </path>
                                                      </svg>
                                                   </span>
                                                </span>
                                             </div>
                                          </div>
                                          <div className="auto-comment-post-item__thumb mr8">
                                             {getPicture(item)
                                                ?
                                                <img src={getPicture(item)} />
                                                :
                                                <div className="default-thumb d-flex-center">
                                                   <div className="svg-next-icon image-default-v2">
                                                   </div>
                                                </div>
                                             }
                                          </div>
                                          <div className="auto-comment-post-item__description ps-relative">
                                             <div className="auto-comment-post-item__description-content text-ellipsis">
                                                <div className="display-flex">
                                                   <span title={item.message}>
                                                      {item.message}
                                                   </span>
                                                </div>
                                             </div>
                                             <div className="text-ellipsis font-size-12 ">
                                                <div className="hover-to-copy-wrapper">
                                                   <div className="hover-to-copy-container">
                                                      <div className="title-copy-to-clipboard child">
                                                         Post ID : {item.id}
                                                         <div className="svg-next-icon button-copy-to-clipboard icon-copy-fill"  >
                                                         </div>
                                                      </div>
                                                   </div>
                                                   <div style={{ position: "absolute", top: 0, left: 0, width: "100%" }}>
                                                      <div>
                                                         <div className="app-tooltip  app-tooltip-placement-bottom  app-tooltip-hidden" style={{ left: 33, top: 44, transformOrigin: "50% -4px" }}>
                                                            <div className="app-tooltip-content">
                                                               <div className="app-tooltip-arrow"></div>
                                                               <div className="app-tooltip-inner" role="tooltip">
                                                                  <div className="svg-next-icon mr2 mb3 icon-check-new">
                                                                  </div>
                                                                  <span> Đã sao chép</span>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                             <div className="auto-comment-post-item__description-info font-size-12 display-flex">
                                                <div>
                                                   <span className="capitalize-first-letter">
                                                      {formatTimeTxt(item.created_time)}
                                                   </span>
                                                </div>
                                                {renderDesc(item)}
                                             </div>
                                          </div>
                                       </div>
                                       <div className="button-go-to-post justify-content-center">
                                          <a className="pointer" href={item.permalink_url} target="_blank">
                                             <button type="button" className="app-btn app-btn-default">
                                                <div className="svg-next-icon ic_link">
                                                </div>
                                             </button>
                                          </a>
                                       </div>
                                    </div>
                                 )
                              })}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="app-modal-footer">
                  <div className="col-auto">
                     {listPostSelected.length > 0 &&
                        <div className="display-flex align-items-center justify-content-space-between">
                           <div>
                              <span>{listPostSelected.length} bài viết được chọn</span>
                           </div>
                           <button type="button" className="app-btn app-btn-primary auto-comment-modal-select__button" onClick={handleAddPostCampaign}>
                              Chọn bài viết
                           </button>
                        </div>
                     }
                  </div>
               </div>
            </div>
         </div>
      </Modal>
   )
}

const mapStateToProps = (state) => {
   const { posts, page } = state;
   return {
      page,
      posts
   };
};

export default connect(mapStateToProps, {
   fetchPosts,
   addPostCampaign,
   fetchListPostCampaign,
   fetchPostReels
})(Posts)
